import { render, staticRenderFns } from "./OrgChartNode.vue?vue&type=template&id=719276e7"
import script from "./OrgChartNode.vue?vue&type=script&lang=js"
export * from "./OrgChartNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('719276e7')) {
      api.createRecord('719276e7', component.options)
    } else {
      api.reload('719276e7', component.options)
    }
    module.hot.accept("./OrgChartNode.vue?vue&type=template&id=719276e7", function () {
      api.rerender('719276e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChart/OrgChartNode.vue"
export default component.exports